import theme from "Styles/theme";
import { Shape, RingAngle } from "./../Data/planet";
import * as THREE from "three";
import { DoubleSide } from "three";

export const renderShape = (shape: Shape, radius: number) => {
	switch (shape) {
		case Shape.OCTAHEDRON: {
			return new THREE.OctahedronGeometry(radius, 0);
		}
		case Shape.BOX: {
			return new THREE.BoxBufferGeometry(radius, radius, radius);
		}
		case Shape.CONE: {
			return new THREE.ConeBufferGeometry(radius * 0.8, radius * 1.4, 3);
		}
		case Shape.CYLINDER: {
			return new THREE.CylinderBufferGeometry(radius * 0.65, radius * 0.65, radius * 1.4, 3);
		}
		case Shape.SPHERE: {
			return new THREE.DodecahedronBufferGeometry(radius * 0.8, 5);
		}
		default: {
			return new THREE.DodecahedronBufferGeometry(radius * 0.65, 5);
		}
	}
};

export const makeAngle = (angle: RingAngle) => {
	switch (angle) {
		case RingAngle.POSITIVE:
			return Math.PI / 4;
		case RingAngle.NEGATIVE:
			return -Math.PI / 4;
		default:
			return 0;
	}
};

export const moveCircleMesh = (mesh: any, radius: number, framecount: number, speed: number = 0.005, rand?: number) => {
	const value = rand ? rand + framecount * speed : framecount * speed;
	mesh.position.x = Math.cos(value) * radius;
	mesh.position.y = Math.sin(value) * radius;
};

export const moveEllipseMesh = (mesh: any, radius: number, angle_x: number, frameCount: number, speed: number = 0.005, rand?: number, radius_z?: boolean) => {
	const value = rand ? rand + frameCount * speed : frameCount * speed;
	mesh.position.x = Math.cos(value) * radius;
	mesh.position.y = Math.sin(value) * Math.cos(angle_x) * radius;
	if (radius_z) {
		mesh.position.z = Math.tan(angle_x) * mesh.position.y;
	}
};

export function setOpacity(obj: any, opacity: number) {
	obj.children.forEach((child: any) => {
		setOpacity(child, opacity);
	});
	if (obj.material) {
		obj.material.opacity = opacity;
	}
}

export const materialDefault = (options?: any) => {
	return new THREE.MeshPhysicalMaterial({
		color: theme.color.default,
		roughness: 1,
		metalness: 0.2,
		transparent: true,
		opacity: 1,
		side: DoubleSide,
		...options
	});
};

export const rotateMesh = (mesh: any, value: number = 0.005) => {
	mesh.rotation.x += value;
	mesh.rotation.y += value;
};

export const genderateRandomRadius = (initRadius: number, gap: number, index: number) => {
	if (index === 0) {
		return initRadius;
	} else {
		return initRadius + (index - 1) * gap + Math.random() * (gap - 20) + 20;
	}
};

export const easeInOut = (t: number, b: number, c: number, d: number = 40) => {
	// t: current time/currnet step
	// b: starting position
	// c: amount of change (end - start)
	// d: total animation time/steps

	if ((t /= d / 2) < 1) return (c / 2) * t * t * t + b;
	return (c / 2) * ((t -= 2) * t * t + 2) + b;
};
